
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/[slug]",
      function () {
        return require("private-next-pages/legal/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/[slug]"])
      });
    }
  